// Returns a truncated string that exceeds a given limit.

function LimitText(string, limit){
  return (string.substring(0, limit) + "...")
}
export default LimitText